import createElementChangeListener from "../elementChangeListener.js";

const wiredComponents = [];

function findAndParseProps(componentWrapper) {
    const propsHolder = componentWrapper.querySelector(
        `:scope > script[type="application/rmprops+json"]`
    );

    const propsText = propsHolder.textContent;

    return JSON.parse(propsText);
}

export function wireComponent(componentName, handler) {
    function onElement(componentWrapper) {
        let props = {};
        try {
            props = findAndParseProps(componentWrapper);
        } catch (error) {
            console.error(`Error finding or parsing component props ${componentName}`, error);
        }

        try {
            handler(componentWrapper, props);
        } catch (error) {
            console.error(`Error executing component handler ${componentName}`, error);
        }
    }

    if (wiredComponents.includes(componentName)) {
        return;
    }

    wiredComponents.push(componentName);

    createElementChangeListener(`.${componentName}`, onElement);
}
